export class FioLine {

  id: string;
  date: string;
  value: number;
  currency: string;
  from: string;
  fromAccount: string;
  bankCode: string;
  varSym: string;
  message: string;

}
